import Analytics from 'analytics'
import getConfig from 'next/config'
import { SplitioPlugin, GlobalTagPlugin, IntercomPlugin } from './plugins'

const {
  publicRuntimeConfig: { splitioAuthorizeKey, googleGlobalTagId, version },
} = getConfig()

const plugins = [
  SplitioPlugin({
    authorizeKey: splitioAuthorizeKey,
  }),
  GlobalTagPlugin({
    id: googleGlobalTagId,
  }),
  IntercomPlugin({}),
]

const analytics = Analytics({
  app: 'utoniq-www',
  version,
  plugins,
})

export default analytics
export * from './context'
